export const CONFIG_UPDATE = 'CONFIG_UPDATE';
export const CONFIG_OAUTH_UPDATE = 'CONFIG_OAUTH_UPDATE';